/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CaptureSigningDetailsCommand,
  CreateAndUploadDocumentOrchestration,
  DeleteConsultantCommand,
  DeleteSignatoryCommand,
  DownloadAndSignViewModel,
  ESignOrchestrator,
  ErrorResult,
  NotFoundErrorResult,
  Result,
  ResultOfApplicationFormViewModel,
  ResultOfCapturedSigningDetailsViewModel,
  ResultOfConsultantViewModel,
  ResultOfListOfAuditTrailSummaryViewModel,
  ResultOfQuicklySignHealthCheckResponse,
  ResultOfSignatoryViewModel,
  ResultOfSigningProgressSummaryViewModel,
  ResultOfSupportingDocumentViewModel,
  UpsertConsultantCommand,
  UpsertSignatoryOrchestration,
  ValidationErrorResult,
} from '../models';
import {
    CaptureSigningDetailsCommandFromJSON,
    CaptureSigningDetailsCommandToJSON,
    CreateAndUploadDocumentOrchestrationFromJSON,
    CreateAndUploadDocumentOrchestrationToJSON,
    DeleteConsultantCommandFromJSON,
    DeleteConsultantCommandToJSON,
    DeleteSignatoryCommandFromJSON,
    DeleteSignatoryCommandToJSON,
    DownloadAndSignViewModelFromJSON,
    DownloadAndSignViewModelToJSON,
    ESignOrchestratorFromJSON,
    ESignOrchestratorToJSON,
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfApplicationFormViewModelFromJSON,
    ResultOfApplicationFormViewModelToJSON,
    ResultOfCapturedSigningDetailsViewModelFromJSON,
    ResultOfCapturedSigningDetailsViewModelToJSON,
    ResultOfConsultantViewModelFromJSON,
    ResultOfConsultantViewModelToJSON,
    ResultOfListOfAuditTrailSummaryViewModelFromJSON,
    ResultOfListOfAuditTrailSummaryViewModelToJSON,
    ResultOfQuicklySignHealthCheckResponseFromJSON,
    ResultOfQuicklySignHealthCheckResponseToJSON,
    ResultOfSignatoryViewModelFromJSON,
    ResultOfSignatoryViewModelToJSON,
    ResultOfSigningProgressSummaryViewModelFromJSON,
    ResultOfSigningProgressSummaryViewModelToJSON,
    ResultOfSupportingDocumentViewModelFromJSON,
    ResultOfSupportingDocumentViewModelToJSON,
    UpsertConsultantCommandFromJSON,
    UpsertConsultantCommandToJSON,
    UpsertSignatoryOrchestrationFromJSON,
    UpsertSignatoryOrchestrationToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface SigningCancelSigningRequest {
    proposalId: number;
}

export interface SigningCreateAndUploadDocumentRequest {
    orchestration: CreateAndUploadDocumentOrchestration;
}

export interface SigningDeleteConsultantRequest {
    command: DeleteConsultantCommand;
}

export interface SigningDownloadAndSignRequest {
    model: DownloadAndSignViewModel;
}

export interface SigningFinaliseProposalRequest {
    proposalId: number;
}

export interface SigningGetAuditTrailForDocumentRequest {
    documentId: number;
    proposalId: number;
}

export interface SigningGetCapturedSigningDetailsRequest {
    proposalId: number;
}

export interface SigningGetSigningProgressSummaryRequest {
    proposalId: number;
}

export interface SigningRemoveSignatoryRequest {
    command: DeleteSignatoryCommand;
}

export interface SigningResendDocumentForSigningRequest {
    documentId: number;
}

export interface SigningSaveCapturedSigningDetailsRequest {
    command: CaptureSigningDetailsCommand;
}

export interface SigningStartSigningRequest {
    proposalId: number;
}

export interface SigningSubmitForInOfficeESignRequest {
    orchestration: ESignOrchestrator;
}

export interface SigningSubmitToESignRequest {
    orchestration: ESignOrchestrator;
}

export interface SigningUpsertConsultantRequest {
    command: UpsertConsultantCommand;
}

export interface SigningUpsertSignatoryRequest {
    orchestration: UpsertSignatoryOrchestration;
}

/**
 * 
 */
export class SigningApi extends runtime.BaseAPI {

    /**
     * Cancel signing
     */
    async signingCancelSigningRaw(requestParameters: SigningCancelSigningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling signingCancelSigning.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/cancel-sigings/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Cancel signing
     */
    async signingCancelSigning(requestParameters: SigningCancelSigningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingCancelSigningRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create and Upload a Document
     */
    async signingCreateAndUploadDocumentRaw(requestParameters: SigningCreateAndUploadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfSupportingDocumentViewModel>> {
        if (requestParameters.orchestration === null || requestParameters.orchestration === undefined) {
            throw new runtime.RequiredError('orchestration','Required parameter requestParameters.orchestration was null or undefined when calling signingCreateAndUploadDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/create-and-upload-documents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAndUploadDocumentOrchestrationToJSON(requestParameters.orchestration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfSupportingDocumentViewModelFromJSON(jsonValue));
    }

    /**
     * Create and Upload a Document
     */
    async signingCreateAndUploadDocument(requestParameters: SigningCreateAndUploadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfSupportingDocumentViewModel> {
        const response = await this.signingCreateAndUploadDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a Consultant
     */
    async signingDeleteConsultantRaw(requestParameters: SigningDeleteConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.command === null || requestParameters.command === undefined) {
            throw new runtime.RequiredError('command','Required parameter requestParameters.command was null or undefined when calling signingDeleteConsultant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/consultant`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteConsultantCommandToJSON(requestParameters.command),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Delete a Consultant
     */
    async signingDeleteConsultant(requestParameters: SigningDeleteConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingDeleteConsultantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Commence with Download and Sign
     */
    async signingDownloadAndSignRaw(requestParameters: SigningDownloadAndSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfApplicationFormViewModel>> {
        if (requestParameters.model === null || requestParameters.model === undefined) {
            throw new runtime.RequiredError('model','Required parameter requestParameters.model was null or undefined when calling signingDownloadAndSign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/download-and-sign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DownloadAndSignViewModelToJSON(requestParameters.model),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfApplicationFormViewModelFromJSON(jsonValue));
    }

    /**
     * Commence with Download and Sign
     */
    async signingDownloadAndSign(requestParameters: SigningDownloadAndSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfApplicationFormViewModel> {
        const response = await this.signingDownloadAndSignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finalise a proposal
     */
    async signingFinaliseProposalRaw(requestParameters: SigningFinaliseProposalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling signingFinaliseProposal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/finalise-proposals/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Finalise a proposal
     */
    async signingFinaliseProposal(requestParameters: SigningFinaliseProposalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingFinaliseProposalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get audit trail entry for a document
     */
    async signingGetAuditTrailForDocumentRaw(requestParameters: SigningGetAuditTrailForDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfAuditTrailSummaryViewModel>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling signingGetAuditTrailForDocument.');
        }

        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling signingGetAuditTrailForDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/get-document-audit-trail/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.proposalId as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfAuditTrailSummaryViewModelFromJSON(jsonValue));
    }

    /**
     * Get audit trail entry for a document
     */
    async signingGetAuditTrailForDocument(requestParameters: SigningGetAuditTrailForDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfAuditTrailSummaryViewModel> {
        const response = await this.signingGetAuditTrailForDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get details captured for signing
     */
    async signingGetCapturedSigningDetailsRaw(requestParameters: SigningGetCapturedSigningDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCapturedSigningDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling signingGetCapturedSigningDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/captured-signing-details/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCapturedSigningDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get details captured for signing
     */
    async signingGetCapturedSigningDetails(requestParameters: SigningGetCapturedSigningDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCapturedSigningDetailsViewModel> {
        const response = await this.signingGetCapturedSigningDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get progress summary for signing
     */
    async signingGetSigningProgressSummaryRaw(requestParameters: SigningGetSigningProgressSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfSigningProgressSummaryViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling signingGetSigningProgressSummary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/signing-progress-summaries/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfSigningProgressSummaryViewModelFromJSON(jsonValue));
    }

    /**
     * Get progress summary for signing
     */
    async signingGetSigningProgressSummary(requestParameters: SigningGetSigningProgressSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfSigningProgressSummaryViewModel> {
        const response = await this.signingGetSigningProgressSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * QuicklySign Health Check
     */
    async signingQuicklySignHealthCheckRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfQuicklySignHealthCheckResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/quickly-sign-health-check`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfQuicklySignHealthCheckResponseFromJSON(jsonValue));
    }

    /**
     * QuicklySign Health Check
     */
    async signingQuicklySignHealthCheck(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfQuicklySignHealthCheckResponse> {
        const response = await this.signingQuicklySignHealthCheckRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete a Signatory
     */
    async signingRemoveSignatoryRaw(requestParameters: SigningRemoveSignatoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.command === null || requestParameters.command === undefined) {
            throw new runtime.RequiredError('command','Required parameter requestParameters.command was null or undefined when calling signingRemoveSignatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/signatory`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteSignatoryCommandToJSON(requestParameters.command),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Delete a Signatory
     */
    async signingRemoveSignatory(requestParameters: SigningRemoveSignatoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingRemoveSignatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resend documents for signing
     */
    async signingResendDocumentForSigningRaw(requestParameters: SigningResendDocumentForSigningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling signingResendDocumentForSigning.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/resend-document-for-signing/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Resend documents for signing
     */
    async signingResendDocumentForSigning(requestParameters: SigningResendDocumentForSigningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingResendDocumentForSigningRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save captured details for signing
     */
    async signingSaveCapturedSigningDetailsRaw(requestParameters: SigningSaveCapturedSigningDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.command === null || requestParameters.command === undefined) {
            throw new runtime.RequiredError('command','Required parameter requestParameters.command was null or undefined when calling signingSaveCapturedSigningDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/save-captured-signing-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CaptureSigningDetailsCommandToJSON(requestParameters.command),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Save captured details for signing
     */
    async signingSaveCapturedSigningDetails(requestParameters: SigningSaveCapturedSigningDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingSaveCapturedSigningDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Move proposal into Signing state
     */
    async signingStartSigningRaw(requestParameters: SigningStartSigningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling signingStartSigning.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/start-signing/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Move proposal into Signing state
     */
    async signingStartSigning(requestParameters: SigningStartSigningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingStartSigningRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Commence with In Office E-Signing
     */
    async signingSubmitForInOfficeESignRaw(requestParameters: SigningSubmitForInOfficeESignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.orchestration === null || requestParameters.orchestration === undefined) {
            throw new runtime.RequiredError('orchestration','Required parameter requestParameters.orchestration was null or undefined when calling signingSubmitForInOfficeESign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/in-office-e-sign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ESignOrchestratorToJSON(requestParameters.orchestration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Commence with In Office E-Signing
     */
    async signingSubmitForInOfficeESign(requestParameters: SigningSubmitForInOfficeESignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingSubmitForInOfficeESignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Commence with E-Signing
     */
    async signingSubmitToESignRaw(requestParameters: SigningSubmitToESignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.orchestration === null || requestParameters.orchestration === undefined) {
            throw new runtime.RequiredError('orchestration','Required parameter requestParameters.orchestration was null or undefined when calling signingSubmitToESign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/e-sign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ESignOrchestratorToJSON(requestParameters.orchestration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Commence with E-Signing
     */
    async signingSubmitToESign(requestParameters: SigningSubmitToESignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.signingSubmitToESignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create or Update a Consultant
     */
    async signingUpsertConsultantRaw(requestParameters: SigningUpsertConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfConsultantViewModel>> {
        if (requestParameters.command === null || requestParameters.command === undefined) {
            throw new runtime.RequiredError('command','Required parameter requestParameters.command was null or undefined when calling signingUpsertConsultant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/upsert-consultant`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertConsultantCommandToJSON(requestParameters.command),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfConsultantViewModelFromJSON(jsonValue));
    }

    /**
     * Create or Update a Consultant
     */
    async signingUpsertConsultant(requestParameters: SigningUpsertConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfConsultantViewModel> {
        const response = await this.signingUpsertConsultantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create or Update a Signatory
     */
    async signingUpsertSignatoryRaw(requestParameters: SigningUpsertSignatoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfSignatoryViewModel>> {
        if (requestParameters.orchestration === null || requestParameters.orchestration === undefined) {
            throw new runtime.RequiredError('orchestration','Required parameter requestParameters.orchestration was null or undefined when calling signingUpsertSignatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/signing/upsert-signatories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertSignatoryOrchestrationToJSON(requestParameters.orchestration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfSignatoryViewModelFromJSON(jsonValue));
    }

    /**
     * Create or Update a Signatory
     */
    async signingUpsertSignatory(requestParameters: SigningUpsertSignatoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfSignatoryViewModel> {
        const response = await this.signingUpsertSignatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
